import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

import { deleteUsuario } from '../api/admin.api'

import './delete-access.css'
import './delete-access-modal.css'

const DeleteAccess = ({ isOpen, onClose, usuario, onSuccess }) => {
  // True while the delete API call is in-flight
  const [loading, setLoading] = useState(false)

  // Sends the delete request; handles known error codes with specific messages
  const handleDelete = async () => {
    if (!usuario) return

    setLoading(true)
    try {
      await deleteUsuario(usuario.id)
      toast.success('Acceso eliminado correctamente')
      onSuccess()
      onClose()
    } catch (err) {
      const code = err?.response?.data?.detail
      if (code === 'USUARIO_DELETE_SELF') {
        toast.error('No puedes eliminar tu propio acceso')
      } else if (code === 'USUARIO_NOT_FOUND') {
        toast.error('Usuario no encontrado')
      } else {
        toast.error('Error al eliminar el acceso')
      }
    } finally {
      setLoading(false)
    }
  }

  // Prevents closing the modal while a delete request is in-flight
  const handleClose = () => {
    if (loading) return
    onClose()
  }

  // Render nothing when the modal is not open
  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={handleClose}>
      {/* Stop propagation so clicks inside the card don't close the modal */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-access-thq-deleteaccess-elm">
          <div className="delete-access-thq-content-elm">
            {/* Warning icon inherited from the original maquette */}
            <img
              src="/warning.svg"
              className="delete-access-thq-icon-elm modal-warning-icon"
              alt="Advertencia"
            />
            <div className="delete-access-thq-title-elm">
              <span className="delete-access-thq-text-elm1 headline01">
                Eliminar acceso
              </span>
              <span className="delete-access-thq-text-elm2 bodystandard">
                {/* Show the target user's email so the admin can confirm the right account */}
                ¿Quieres eliminar el acceso de{' '}
                <strong>{usuario?.email ?? 'este usuario'}</strong>?
                <br />
                Esta acción no se puede deshacer.
              </span>
            </div>
          </div>
          <div className="modal-buttons">
            <button
              type="button"
              className="btn-cancel"
              onClick={handleClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn-delete"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? 'Eliminando...' : 'Eliminar acceso'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

DeleteAccess.defaultProps = {
  usuario: null,
}

DeleteAccess.propTypes = {
  // Controls modal visibility
  isOpen:    PropTypes.bool.isRequired,
  // Callback to close the modal
  onClose:   PropTypes.func.isRequired,
  // User object to delete; null when no user is selected
  usuario:   PropTypes.object,
  // Called after successful deletion
  onSuccess: PropTypes.func.isRequired,
}

export default DeleteAccess
